(function () {
  if (customElements.get('dtc-video-lightbox')) return;

  function youtubeId(value) {
    try {
      var url = new URL(value);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
      var host = url.hostname.toLowerCase().replace(/^www\./, '');
      var id;
      if (host === 'youtu.be') id = url.pathname.split('/')[1];
      else if (['youtube.com', 'm.youtube.com', 'youtube-nocookie.com'].includes(host)) {
        id = url.pathname === '/watch' ? url.searchParams.get('v') :
          /^\/(?:embed|shorts|live)\/([^/]+)/.exec(url.pathname)?.[1];
      }
      return /^[\w-]{11}$/.test(id || '') ? id : null;
    } catch (error) { return null; }
  }

  class DtcVideoLightbox extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.dtc-video-player');
      this.events = new AbortController();
      var options = { signal: this.events.signal };
      document.addEventListener('click', this.onTrigger = this.openFromTrigger.bind(this), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.closest('.dtc-video-close')) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.cleanup(), options);
    }

    openFromTrigger(event) {
      var trigger = event.target.closest('[data-dtc-video]');
      if (!trigger || trigger.getAttribute('aria-controls') !== this.id) return;
      if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var swiper = trigger.closest('.swiper')?.swiper;
      if (swiper && swiper.allowClick === false) { event.preventDefault(); return; }
      var id = youtubeId(trigger.href);
      if (!id) return;
      event.preventDefault();
      if (this.dialog.open) return;

      this.trigger = trigger;
      this.swiper = swiper;
      this.resumeAutoplay = Boolean(swiper?.autoplay?.running);
      if (this.resumeAutoplay) swiper.autoplay.stop();
      this.lenis = window.dtcLenis;
      this.resumeLenis = Boolean(this.lenis && !this.lenis.isStopped);
      if (this.resumeLenis) this.lenis.stop();
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';

      var iframe = document.createElement('iframe');
      iframe.title = trigger.getAttribute('aria-label') || 'YouTube video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0';
      this.player.replaceChildren(iframe);
      this.dialog.showModal();
    }

    cleanup() {
      this.player.replaceChildren();
      if (!this.trigger) return;
      document.documentElement.style.overflow = this.previousOverflow;
      if (this.resumeLenis) this.lenis.start();
      if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      if (this.resumeAutoplay && !this.swiper.destroyed) this.swiper.autoplay.start();
      this.trigger = null;
    }

    disconnectedCallback() {
      this.cleanup();
      this.events.abort();
    }
  }

  customElements.define('dtc-video-lightbox', DtcVideoLightbox);
})();
